// AbTodayStats — Kennzahlen heute (Eingang/Erkannt/Freigegeben/Abgelehnt) als kleine Kacheln.

import React from 'react';
import { Card, SectionTitle } from '../ui';

const AbTodayStats = ({ today, isDarkMode, t }) => {
  const textMuted = isDarkMode ? 'text-white/40' : 'text-slate-400';
  const hasData = today && (today.received > 0 || today.extracted > 0 || today.approved > 0 || today.rejected > 0);

  const tiles = [
    { v: today?.received ?? 0, l: t('ab.shell.todayReceived') },
    { v: today?.extracted ?? 0, l: t('ab.shell.todayExtracted') },
    { v: today?.approved ?? 0, l: t('ab.shell.todayApproved') },
    { v: today?.rejected ?? 0, l: t('ab.shell.todayRejected') },
  ];

  return (
    <Card isDarkMode={isDarkMode}>
      <SectionTitle isDarkMode={isDarkMode}>{t('ab.shell.todayTitle')}</SectionTitle>
      {!hasData ? (
        <p className={`text-sm ${textMuted}`}>{t('ab.shell.todayEmpty')}</p>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {tiles.map((tile) => (
            <div key={tile.l} className={`rounded-xl p-3 text-center ${isDarkMode ? 'bg-white/5' : 'bg-slate-50'}`}>
              <div className={`text-xl font-bold tabular-nums ${isDarkMode ? 'text-white/90' : 'text-slate-800'}`}>{tile.v}</div>
              <div className={`text-[11px] mt-0.5 ${textMuted}`}>{tile.l}</div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default AbTodayStats;
